import { applyMiddleware, createStore, compose, AnyAction } from 'redux';
import thunkMiddleware, { ThunkDispatch } from 'redux-thunk';
import { userActionLogMiddleware } from 'utils/supportContext/actionLog';
import rootReducer from './reducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

export type ReduxState = ReturnType<typeof rootReducer>;

export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;

export function configureStore(initialState?: ReduxState) {
  const composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    compose;

  const middleWare = [thunkMiddleware, userActionLogMiddleware];

  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleWare)));
}
